import {Directive, ElementRef, forwardRef, Input, Renderer2} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {payrollNumberDisplay} from 'app/models/payroll-number-display';

const EMPTY_TEXT = '';
const VALUE_PROPERTY = 'value';
const DISABLED_PROPERTY = 'disabled';
const DECIMAL_SEPARATOR = '.';
const DECIMAL_COMMA = ',';
const DECIMAL_TEXT = /^-?(?:\d+\.?\d*|\.\d+)$/;
const NO_DECIMAL = -1;
const DEFAULT_PRECISION = 2;
const COEFFICIENT_PRECISION = 3;
const DECIMAL_LENGTH = 1;
const NO_FRACTION = 0;

@Directive({
  selector: 'input[dealPayrollDecimalInput]',
  providers: [{provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DealPayrollDecimalInputDirective), multi: true}],
  host: {'(input)': 'input($event.target.value)', '(blur)': 'blur()'}
})
export class DealPayrollDecimalInputDirective implements ControlValueAccessor {
  @Input() dealPayrollDecimalPrecision = DEFAULT_PRECISION;
  private disabled = false;
  private changed: (value: number) => void = () => undefined;
  private touched: () => void = () => undefined;

  constructor(private element: ElementRef, private renderer: Renderer2) {}

  writeValue(value: number | string): void {
    const text = value == null ? EMPTY_TEXT : String(value);
    const display = text && isFinite(Number(text)) ? this.displayLoaded(text, value) : EMPTY_TEXT;
    this.writeText(display);
  }

  registerOnChange(changed: (value: number) => void): void { this.changed = changed; }
  registerOnTouched(touched: () => void): void { this.touched = touched; }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
    this.renderer.setProperty(this.element.nativeElement, DISABLED_PROPERTY, disabled);
  }

  input(value: string): void {
    if (this.disabled) { return; }
    const limited = limitFraction(value, this.dealPayrollDecimalPrecision);
    if (limited !== value) { this.writeText(limited); }
    this.changed(limited === EMPTY_TEXT ? null : Number(limited));
  }

  blur(): void { this.touched(); }

  private displayLoaded(text: string, value: number | string): string {
    return this.dealPayrollDecimalPrecision === COEFFICIENT_PRECISION
      || limitFraction(text, this.dealPayrollDecimalPrecision) === text ? text : payrollNumberDisplay(value);
  }

  private writeText(value: string): void {
    this.renderer.setProperty(this.element.nativeElement, VALUE_PROPERTY, value);
  }
}

function limitFraction(value: string, precision: number): string {
  const text = value.trim().replace(DECIMAL_COMMA, DECIMAL_SEPARATOR);
  if (!DECIMAL_TEXT.test(text) || !isFinite(Number(text))) { return EMPTY_TEXT; }
  const decimal = text.indexOf(DECIMAL_SEPARATOR);
  return decimal === NO_DECIMAL ? text : text.slice(undefined, decimal + precision + (precision ? DECIMAL_LENGTH : NO_FRACTION));
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-group/deal-payroll-group-settings/deal-payroll-decimal-input.directive.ts